/**
 * Fetches our own captured screens for an app, in parallel with the other app
 * detail slices. Never gates first paint; null means the section hides.
 */

import { useQuery } from '@tanstack/react-query';
import type { FirstPartyCatalog } from '@/lib/firstparty/types';

export function useAppFirstParty(appId: number) {
  const { data, isLoading } = useQuery<FirstPartyCatalog | null, Error>({
    queryKey: ['app-first-party', appId],
    queryFn: async () => {
      const res = await fetch(`/api/app-detail/first-party?appId=${appId}`);
      if (!res.ok) return null;
      return ((await res.json()) as { catalog: FirstPartyCatalog | null }).catalog;
    },
    enabled: !!appId,
    staleTime: 24 * 60 * 60 * 1000,
  });

  return { catalog: data ?? null, isLoading };
}
